module.exports = __webpack_public_path__ + "img/content_pic03.325b4ed5.jpg";